import $ from 'jquery';
import elementIsVisible from '../../core/INF-elementIsVisible';
import { resizeVideo } from './resizeVideos';
import initControls from './initControls';

// Make an index of videos for potential use later in theme editor
const native_players = {};

const nativePlayerInit = (container, start = 0) => {
  const $container = $(container);
  const $player = $(container).find('[data-video-player]');
  const player_id = $player.attr('id');

  resizeVideo($container);

  const canPlayThrough = () => {
    native_players[player_id] = $player[0];

    setTimeout(() => {
      if (elementIsVisible($container)) {
        native_players[player_id].currentTime = start;
        native_players[player_id].play();
      }
      
      initControls($container, native_players[player_id], 'native');
      
      if (start > 0) {
        // Don't fade away the poster, we want to immediately disapear so we resume where we were
        $container.addClass('BackgroundVideo--immediate');
      }

      $container.addClass('BackgroundVideo--init');
    }, 50);
  };

  // This fires when the video can play, but it may happen before JS is even loaded
  $player.on('canplaythrough', () => {
    if (native_players[player_id]) {
      return;
    }

    canPlayThrough();  
  });

  // In case that happens, when JS loads, we check the ready state too.
  if ($player[0].readyState > 3 && !native_players[player_id]) {
    canPlayThrough();
  } else if ($player[0].readyState < 4 && !native_players[player_id]) {
    // iOS fix...we have to explicitly tell the video to play/pause to get it to load
    $player[0].load();
  }
  
};

export {
  native_players,
  nativePlayerInit,
};